import { allTrackers } from "app/services/track/track";

import createFindAppsTrackingService from "./factory";

const findAppsTrackingService = createFindAppsTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

export default findAppsTrackingService;
